/* istanbul ignore file */
import { CURRENCY_TYPES } from 'domain/shared/core/constants';
import { CurrencyDropdown } from 'domain/shared/core/input';
import { EnumDropdownProps } from 'framework/form';

const { EUR, ...DROPDOWN_CURRENCY_TYPES } = CURRENCY_TYPES || {};

export { DROPDOWN_CURRENCY_TYPES };

const CurrencyDropdownWithoutEur = (props: Omit<EnumDropdownProps, 'options'> & { options?: Dictionary<string> }) => {
  return <CurrencyDropdown options={DROPDOWN_CURRENCY_TYPES} {...props} />;
};

export default CurrencyDropdownWithoutEur;
